/* eslint-disable import/no-anonymous-default-export */
import apiCall from "./apiCall";
export default {

    async getStudents(data) {

      const response = await apiCall("student/filter", data);
      return response;

    },

    async registerStudent(data) {
       let response = await apiCall("student/register", data);
        return response;
      },
      async importStudents(data) {

        let response = await apiCall("student/import", data);
        return response;
       
      },

      async getStudentPopulation() {
         let response = await apiCall("student/population", []);
        return response;
      },


      async updateStudent(data) {
        let response = await apiCall("student/update", data);
        return response;

      },

      async fetchContacts(data) {

        let response = await apiCall("student/contact", data);
        return response;

      },

      async addContact(data) {

        let response = await apiCall("student/contact/add", data);
        return response;

      },


      async fetchContactTypo() {

        let response = await apiCall("student/contact/types", []);
        return response;

      },

      async updateContact(data) {

        let response = await apiCall("student/contact/update", data);
        return response;

      },


      async getStudentInfo(studentId) {

        let response = await apiCall("student/info", {student_id:studentId});
        return response;

      },

       async makeDefaultContact(contactId) {

        let response = await apiCall("student/contact/default/update", {contact_id:contactId});
        return response;
      },

       async deleteContact(contactId) {

        let response = await apiCall("student/contactperson/delete_contact", {contact_id:contactId});
        return response;
      },

      async changeStudentStatus(data) {

        let response = await apiCall("student/student/change_status", data);
        return response;

      },

      async uploadStudentFile(data) {
        let response = await apiCall("student/studentfile/add_file", data);
        return response;

      },

      async fetchStudentFiles(studentId) {
        const data = { student_id: studentId };
        let response = await apiCall("student/studentfile/get_files", data);
        return response;
      },

      async deleteStudentFile(fileId) {
        const data = { file_id: fileId };
        let response = await apiCall("student/studentfile/delete_file", data);
        return response;
      },

      async updateStudentPhoto(data) {
        let response = await apiCall("student/student/change_photo", data);
        return response;
      },

      async fetchAlumniCount() {
        let response = await apiCall("student/student/count_alumni", []);
        return response;
      },

      async fetchFeesBalances(data){
        let response = await apiCall("student/feesbalance/list_student_balances", data);
        return response;
      },
      async syncFeesBalances(data){
        let response = await apiCall("student/balance/sync", data);
        return response;
     },
     async fetchClassPopulation(data){
        return await apiCall("student/student/class_population", data);
      },
      async transferStudents(data){
        let response = await apiCall("student/student/class_transfer", data);
        return response;
      },
      async markClassCompleted(data){
        let response = await apiCall("student/student/mark_class_completed", data);
        return response;
      },
      

}